import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { renderPopulateListRelsFunctionRenderer } from '@next-adapter/templates/renderers/generators/actions/action-helpers/generate-populate-list-rels-function.js'
export function generatePopulateListRelsFunction(
  queries: Array<{
    fieldPath: string
    relField: SchemaField
    relTable: string
    listFieldName: string
  }>,
  Singular: string
): string {
  const blocks = queries.map((q) => {
    const v = `${q.fieldPath}_${q.relField.name}`
    return renderPopulateListRelsFunctionRenderer({
      kind: 'renderPopulateListRelsFunctionResultTemplate',
      props: {
        v: v,
        qListFieldName: q.listFieldName,
        qRelFieldName: q.relField.name,
        qRelTable: q.relTable
      }
    })
  })

  return renderPopulateListRelsFunctionRenderer({
    kind: 'renderPopulateListRelsFunctionContentTemplate',
    props: {
      singular: Singular,
      join: blocks.join('\n\n')
    }
  })
}
